import styled from 'styled-components';

import Picture from 'components/picture';
import BlockRenderer from 'components/sanity-block-renderer';

/**
 * offers
 */
export const OffersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  max-width: ${Styles.layout.sectionMaxWidth};
  margin: 0 -5px 3rem -10px;
  width: 100%;

  ${Styles.mobile`
    flex-direction: column;
    margin: 0 auto;
  `}
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 18rem;
  width: 100%;
`;

/**
 * offer
 */

export const Wrapper = styled.button`
  height: 100%;
  display: flex;
  appearance: none;
  border: none;
  /* margin: 0 2rem 0; */
  margin: 0.25rem 0rem;
  padding: 0;
  font-size: inherit;
  font-family: ${Styles.fontFamily.alternative};
  position: relative;
  text-align: left;
  background: transparent;
  z-index: 0;
  user-select: none;
  cursor: pointer;
  flex-direction: column;
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0px 0px 0px 3px ${Styles.color.grey.four};
  }

  /* width: 170px; */
  width: 146px;
  min-height: 290px;

  ${Styles.desktop`
    width: 250px;
  `}
`;

/**
 * Wraps The top offer content to allow for keeping at the
 * top of the content area while flex justifying space between
 * to keep other content at the bottom.
 */
export const OfferContentWrap = styled.div`
  margin-bottom: 0.5rem;
`;

export const Heading = styled.h2<{ length: number }>`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.alternative};
  font-size: 1.25rem;
  line-height: 0.95;
  font-weight: 600;
  margin: 0;

  ${Styles.desktop`
    font-size: 1.5rem;
  `}
`;

/**
 * Offer Expiration text
 */
export const OfferExpiration = styled.p`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.alternative};
  font-size: 0.75rem;
  line-height: 1.1;
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;

  ${Styles.desktop`
    font-size: 0.9rem;
  `}
`;

export const OfferContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: column nowrap;
  flex: auto;
  justify-content: space-between;
  padding: 1rem;
  width: 100%;
`;

export const SanityDescription = styled(BlockRenderer)`
  p {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.alternative};
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.1;
    margin: 0.5rem 0;

    ${Styles.desktop`
      margin: 1rem 0;
    `}
  }
`;

export const StyledPicture = styled(Picture)`
  position: relative;
  border-top-left-radius: ${Styles.borderRadius};
  border-top-right-radius: ${Styles.borderRadius};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  width: 146px;
  height: calc(146px / 1.5);

  ${Styles.desktop`
    width: 250px;
    height: calc(250px / 1.5);
  `}
`;
